import { lazy } from 'react';

import fetchErrorHandler from 'utils/fetchErrorHandler/fetchErrorHandler';

const lazyPreload = importStatement => {
  const load = () =>
    importStatement().catch(error => {
      fetchErrorHandler(error);
      throw error;
    });

  const Component = lazy(load);
  Component.preload = load;
  return Component;
};

export default lazyPreload;
